import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const SectionHeader = styled(Box)(() => ({
  padding: "8px 16px",
  backgroundColor: colors.background.default,
  borderBottom: `1px solid ${colors.border.light}`,
}));

export const SectionHeaderText = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: 600,
  color: colors.text.secondary,
  textTransform: "uppercase",
}));

export const ClearButton = styled(Box)(() => ({
  padding: "8px 16px",
  backgroundColor: colors.background.lightBlue,
  borderBottom: `1px solid ${colors.border.light}`,
  cursor: "pointer",
  "&:hover": {
    backgroundColor: colors.background.lightBlue,
    opacity: 0.9,
  },
}));

export const ClearButtonText = styled(Typography)(() => ({
  fontSize: "12px",
  color: colors.primary.main,
  fontWeight: 500,
}));

export const CustomProcedureItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "canSelect",
})<{ isSelected?: boolean; canSelect?: boolean }>(({ isSelected, canSelect }) => ({
  display: "flex",
  alignItems: "center",
  padding: "6px 12px",
  borderRadius: isSelected ? "4px" : undefined,
  backgroundColor: isSelected ? colors.background.lightBlue : undefined,
  minHeight: "auto",
  cursor: canSelect ? "pointer" : "not-allowed",
  opacity: canSelect ? 1 : 0.5,
  "&:hover": canSelect && !isSelected ? {
    backgroundColor: colors.background.default,
  } : {},
}));

export const CdtCodeItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "isDisabled" && prop !== "isFromBundle",
})<{ isSelected?: boolean; isDisabled?: boolean; isFromBundle?: boolean }>(({ isSelected, isDisabled, isFromBundle }) => ({
  display: "flex",
  alignItems: "center",
  padding: "6px 12px",
  borderRadius: isSelected ? "4px" : undefined,
  backgroundColor: isFromBundle
    ? `${colors.background.lightBlue}!important`
    : isSelected
    ? colors.background.lightBlue
    : undefined,
  minHeight: "auto",
  cursor: isDisabled ? "not-allowed" : "pointer",
  opacity: isDisabled ? 0.5 : 1,
  "&:hover": !isDisabled && !isSelected ? {
    backgroundColor: colors.background.default,
  } : {},
}));

export const ItemLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isFromBundle",
})<{ isFromBundle?: boolean }>(({ isFromBundle }) => ({
  fontSize: "14px",
  color: isFromBundle ? colors.primary.main : colors.text.primary,
}));

export const EmptyMessage = styled(Typography)(() => ({
  fontSize: "14px",
  color: colors.text.secondary,
}));

export const BundleChip = styled(Box)(() => ({
  height: "24px",
  flexShrink: 0,
  backgroundColor: colors.background.lightBlue,
  border: `1px solid ${colors.primary.main}`,
  borderRadius: "16px",
  padding: "0 8px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  fontSize: "14px",
  color: colors.text.primary,
}));
